import React,{useEffect, useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
//import {Link} from 'react-router-dom'
//import Grid from '@mui/material/Grid';
//import Paper from '@mui/material/Paper';
//import Container from '@mui/material/Container';
//import List from '@mui/material/List';
//import ListItem from '@mui/material/ListItem';
//import ListItemIcon from '@mui/material/ListItemIcon';
//import ListItemText from '@mui/material/ListItemText';
//import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
//import Avatar from '@mui/material/Avatar';
//import Divider from '@mui/material/Divider';
//import Collapse from '@mui/material/Collapse';

//import PersonIcon from '@mui/icons-material/Person';
//import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
//import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
//import FaceIcon from '@mui/icons-material/Face';
//import UploadFileIcon from '@mui/icons-material/UploadFile';
//import CreditScoreIcon from '@mui/icons-material/CreditScore';
//import ReceiptIcon from '@mui/icons-material/Receipt';
//import PublicIcon from '@mui/icons-material/Public';
//import RuleIcon from '@mui/icons-material/Rule';
//import SecurityIcon from '@mui/icons-material/Security';
//import Paper from '@mui/material/Paper';
import GuideIndex from './GuideIndex';
import GuideDetail from './GuideDetail';
import Loading from './Loading';
//import Title from './Title';
//import useStyles from './Styles';
import {HelpDict} from './GuideDict';
import Ajax from './Ajax';

//import PageTitle from './PageTitle';
//import {useStyles} from './useStyles';

interface GuideProps {
    
}

interface HelpIndexProps extends RouteComponentProps<{helpGroup:string,helpId:string}> {
	
}

const Help:React.FC<GuideProps> = (props)=> {
	const [loading,setLoading] = useState(true);
	const [helpDict,setHelpDict] = useState({} as HelpDict);

    const hip:HelpIndexProps = useReactRouter();
    const helpId = hip.match.params.helpId;
    const helpGroup = hip.match.params.helpGroup;

	let detail = false;

	if( helpDict[helpGroup] ){
		detail = true;
	}

	useEffect(()=>{
		Ajax.setEditorId(0);
		Ajax.send("guide/dict",{},(res:any)=>{
			setHelpDict(res.dict);
			setLoading(false);
		});
	},[])

	useEffect(()=>{
		window.scroll(0,0);
	},[helpId,helpGroup]);

	return (
		<>
		{loading ? (
			<Loading isLoading={true}/>
		):(
			<>
			{!detail ? (
			<GuideIndex dict={helpDict}/>
			):(
			<GuideDetail dict={helpDict} group={helpGroup} id={helpId}/>
			)}
			</>
		)
		}
		</>
	)
}

export default Help;